module.exports = __webpack_public_path__ + "media/images/tick_white-f835c963767709c71115d3d5fe5b57cc.svg";